import { withStyles } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const styles = (theme) => ({
  closedDay: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    paddingBottom: 20
  },
  infoOutlinedIconStyle: {
    paddingLeft: 7
  },
  title: {
    fontSize: theme.textFontSize,
    fontWeight: 'bold',
    paddingTop: 10,
    paddingBottom: 10,
    textTransform: 'uppercase',
  },
});
const InfoHeader = ({ classes, title }) => {
  return (
    <>
      {title && <div className={classes.title}>{title}</div>}
      <div className={classes.closedDay}>
        <InfoOutlinedIcon />
        <span className={classes.infoOutlinedIconStyle}>00:00 signifies marked closed</span>
      </div>
    </>
  );
};

export default withStyles(styles)(InfoHeader);
